import React from 'react';
import PropTypes from 'prop-types';
import ImageField from './ImageField';
import VideoField from './VideoField';
import TextField from './TextField';
import { FieldRow, FieldCol, fieldType } from './helpers';

function FieldEditor({ field }) {
  const { contentType } = field;

  switch (contentType) {
    case 'standard':
      return <TextField field={field} />;
    case 'formatted_text':
      return <TextField field={field} />;
    case 'image':
      return <ImageField field={field} />;
    case 'video':
      return <VideoField field={field} />;
    default:
      console.error(`Unrecognized contentType ${contentType} for field:`, field);
      return null;
  }
}

FieldEditor.propTypes = {
  field: fieldType.isRequired
};

function CustomField({ field }) {
  return (
    <FieldRow>
      <FieldCol>
        <FieldEditor field={field} />
      </FieldCol>
    </FieldRow>
  );
}

CustomField.propTypes = {
  field: fieldType.isRequired
};

export default function CustomFields({ fields }) {
  if (!fields.length) return null;

  return (
    <React.Fragment>
      {fields.map((field) => (
        <CustomField key={`field-${field.id}`} field={field} />
      ))}
    </React.Fragment>
  );
}

export {
  fieldType
};

CustomFields.propTypes = {
  fields: PropTypes.arrayOf(fieldType).isRequired
};




// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/customFields/index.jsx